module.exports = __webpack_public_path__ + "static/media/backsvg3.055752b7.svg";